import { createFileRoute } from "@tanstack/react-router";
import { CheckEmail } from "@/components/auth-flows";

export const Route = createFileRoute("/verify-email")({
  head: () => ({
    meta: [
      { title: "Xamseen — Verify your email" },
      { name: "description", content: "Confirm your email address to activate your Xamseen account." },
      { property: "og:title", content: "Verify your Xamseen email" },
      { property: "og:description", content: "Confirm your email address to activate your Xamseen account." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <CheckEmail />,
});
